import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideQueryService } from 'src/app/core/services/query.service';
import { PSA_ENDPOINT, psaStateConfig } from '../psa/psa.config';
import { PsaService } from '../psa/psa.service';
import {  Psa, PsaState } from '../psa/psa.model';
import { Filiere } from './filiere.model';
import { Complaint } from './complaint.model';
import { ComplaintService } from './services/complaint.service';
import { COMPLAINT_ENDPOINT, complaintStateConfig, CATALOG_SECTION_ENDPOINT, CATALOG_SPINNERET_ENDPOINT, catalogSectionStateConfig, catalogSpinneretStateConfig, FILIERE_ENDPOINT, filiereStateConfig, INTERNODO_ENDPOINT, internodoStateConfig, NODE_ENDPOINT, nodeStateConfig, PRIORITY_BUILDING_ENDPOINT, priorityBuildingStateConfig, networkLossStateConfig, NETWORK_LOSS_ENDPOINT } from './filiere.config';
import { FiliereService } from './services/filiere.service';
import { InterNodo } from './internodo.model';
import { InterNodeService } from './services/internode.service';
import { CatalogSpinneretService } from './services/catalog-spinneret.service';
import { NodeService } from './services/node.service';
import { CatalogSectionService } from './services/catalog-section.service';
import { BuildingsService } from './services/buildings.service';
import { NetworkLossService } from './services/network-loss.service';


@NgModule({
  declarations: [],
  providers: [
    ...provideQueryService<Psa>(PSA_ENDPOINT, psaStateConfig),
    PsaService,
    ...provideQueryService<Filiere>(FILIERE_ENDPOINT, filiereStateConfig),
    FiliereService,
    ...provideQueryService<InterNodo>(INTERNODO_ENDPOINT, internodoStateConfig),
    InterNodeService,
    ...provideQueryService<Complaint>(COMPLAINT_ENDPOINT, complaintStateConfig),
    ComplaintService,
    ...provideQueryService<any>(NETWORK_LOSS_ENDPOINT, networkLossStateConfig),
    NetworkLossService,
    ...provideQueryService(CATALOG_SPINNERET_ENDPOINT, catalogSpinneretStateConfig),
    CatalogSpinneretService,
    ...provideQueryService(NODE_ENDPOINT, nodeStateConfig),
    NodeService,
    ...provideQueryService(CATALOG_SECTION_ENDPOINT, catalogSectionStateConfig),
    CatalogSectionService,
    ...provideQueryService(PRIORITY_BUILDING_ENDPOINT, priorityBuildingStateConfig),
    BuildingsService,
  ],
  imports: [
    CommonModule,
  ],
})
export class FiliereModule { }